module.exports = __webpack_public_path__ + "media/components/app-store/static/s7-cf9cbae3c345d12c7aed149d095b6246.png";